import React from 'react';

const DropFileIcon = (props) => {
  let fill = props.fill ? props.fill : '#000';
  let fillOpacity = props.fill ? 1 : 0.38;

  return (
    <svg width="66" height="67" viewBox="0 0 66 67" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.3916 7.84607C14.5182 7.84607 12.1888 10.1754 12.1888 13.0489V54.6712C12.1888 57.5447 14.5181 59.874 17.3916 59.874H48.6084C51.4818 59.874 53.8112 57.5447 53.8112 54.6712V24.3216H43.4056C40.0533 24.3216 37.3357 21.604 37.3357 18.2517V7.84612H37.805L37.782 7.84607H17.3916ZM39.0699 8.00799V18.2517C39.0699 20.6462 41.0111 22.5874 43.4056 22.5874H53.6493C53.42 21.6901 52.9532 20.8623 52.2873 20.1963L41.4609 9.36993C40.795 8.70402 39.9671 8.23726 39.0699 8.00799ZM33.8671 31.2587L37.5091 36.1147C37.7964 36.4978 38.34 36.5754 38.7231 36.2881C39.1062 36.0007 39.1838 35.4572 38.8965 35.0741L35.0811 29.9869C34.0406 28.5995 31.9594 28.5995 30.9189 29.9869L27.1035 35.0741C26.8162 35.4572 26.8938 36.0007 27.2769 36.2881C27.66 36.5754 28.2036 36.4978 28.4909 36.1147L32.1329 31.2587V46C32.1329 46.4789 32.5211 46.8671 33 46.8671C33.4789 46.8671 33.8671 46.4789 33.8671 46V31.2587Z"
        fill={fill}
      />
    </svg>
  );
};

export default DropFileIcon;
